import React, { useEffect, useContext } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import styles from './style.css';
import { FlowContext } from '../../core/flow-engine';
import { navigateToLogin, runDebounced } from '../../flows/shared/utils';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import Heading from '../../components/Typography/Heading/Heading';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';

const RJEmailSearchScreen = () => {
  const { next, appState, formProps } = useContext(FlowContext);
  const {
    store: { authenticated, app },
    inputs
  } = appState;

  const { customer } = app;

  const primaryEmailAddress = authenticated
    ? customer?.primaryEmailAddress
    : inputs.primaryEmailAddress;

  useEffect(() => {
    if (authenticated) {
      runDebounced(() => next()());
    }
  }, []);

  return (
    <div className="container" id="profile-email-header">
      <div className="headers-wrapper">
        <Heading>
          Enter the email you used on your application to view your saved work
        </Heading>
        {authenticated || (
          <div className="login-cta">
            If you have an account,{' '}
            <span className="login-btn">
              <MFBeaconButton
                type="button"
                id="returnJourneyLoginLink"
                onClick={navigateToLogin}
                onKeyPress={navigateToLogin}
                variant="tertiary"
                label="Log in"
              />
            </span>{' '}
            to get started.
          </div>
        )}
      </div>
      <div>
        <div className="form-group">
          <div className="form">
            <InputField
              title="My email is"
              type="email"
              name="profileEmail"
              id="emailAddress"
              {...formProps.primaryEmailAddress}
              defaultValue={primaryEmailAddress}
              className="blocked_data"
            />
          </div>
        </div>
      </div>
      <div className="email-btn-container">
        <MFBeaconButton
          variant="primary"
          size="normal"
          id="returnJourneyEmailContinue"
          className="continue-btn"
          onClick={next('some value')}
          label="Continue"
        />
      </div>
      <PhoneNumber screen="default" />
      <style jsx>{styles}</style>
    </div>
  );
};

export default RJEmailSearchScreen;
